import { Environment } from "relay-runtime";
import { relayNetwork } from "./network";

export const environment = new Environment({
	network: relayNetwork,
});
